/**
 * RichText Component
 *
 * This is a re-export of the server component to keep the heavy
 * Lexical library on the server side only, reducing client bundle size.
 *
 * The actual implementation is in ./server.tsx
 */
export { default } from './server'
